import Pagination from '@/pages/board/_components/pagination'
import {
  FeedbackListData,
  formatDateString,
  PraiseIcon,
  smartLineBreak,
} from '../feedbackItem'
import '../feedback.css'
import { formatDate } from '@/pages/promotion/promotionItem'
import LikeButton from './likeButton'
import GGOOLLFF from '@/assets/images/thumbnaillogo500px.png'

type PraiseProps = {
  page: number
  praiseList: FeedbackListData[]
  praiseCnt: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  handleDetailView: (nttSn: number) => void
  maxDisplayedItems: number
  isMobile: boolean
  activeTab?: string
}

// NoResult 컴포넌트
const NoResult = () => (
  <div className="no-result type-01">
    <div>
      <img src={GGOOLLFF} alt="" width={'200px'} />
    </div>
    <div>아직 등록된 내용이 없거나, 찾으시는 결과가 없어요.</div>
  </div>
)

// 빈 아이템 컴포넌트 (높이 맞추기용)
const EmptyItem = () => (
  <div className="praise-item empty-item">
    <div className="centered-container">
      <div className="centered-text">&nbsp;</div>
    </div>
    <div className="feedback-meta-text">&nbsp;</div>
    <div className="praise-divider" />
    <div className="feedback-meta">
      <div className="feedback-info">
        <div className="feedback-meta-text">
          <span className="feedback-nttSj">&nbsp;</span>
        </div>
        <div className="feedback-meta-subtext">&nbsp;</div>
      </div>
    </div>
  </div>
)

export const Praise: React.FC<PraiseProps> = ({
  page,
  praiseList,
  praiseCnt,
  setPage,
  handleDetailView,
  maxDisplayedItems,
  isMobile,
  activeTab,
}) => {
  const handlePageChange = (newPage: number) => {
    setPage(newPage)
  }

  // 현재 표시되는 아이템 수와 최대 아이템 수의 차이만큼 빈 아이템 생성
  const currentItemCount = praiseList.length
  const emptyItemsCount = Math.max(0, maxDisplayedItems - currentItemCount)
  const emptyItems = Array.from(
    { length: emptyItemsCount },
    (_, index) => index,
  )

  return (
    <>
      {!isMobile ? (
        <div className="feedback-section">
          <div className="feedback-title">
            <span>꿀소리</span>
            <PraiseIcon />
          </div>
          <div className="title-divider border-green" />
          {praiseList.length > 0 ? (
            <>
              <div className="feedback-list-container">
                {praiseList.map((item, index) => (
                  <div key={item.nttSn} className="praise-item">
                    <div
                      className="centered-container"
                      onClick={() => handleDetailView(item.nttSn)}
                    >
                      <div className="centered-text">
                        {smartLineBreak(item.bizNm)}
                      </div>
                    </div>
                    <div className="feedback-meta-text">
                      {`라운드날짜 : ${formatDateString(item.rndDt)}`}
                    </div>
                    <div className="praise-divider" />
                    <div className="feedback-meta">
                      <div className="feedback-info">
                        <div className="feedback-meta-text" title={item.nttSj}>
                          <span className="feedback-nttSj">{item.nttSj}</span>
                          {item.answerCnt ? (
                            <span className="feedback-answer-count">
                              [{item.answerCnt}]
                            </span>
                          ) : null}
                        </div>
                        {/* <div className="feedback-meta-subtext">
                        {`작성자 : ${item.nickName} | 작성일 : ${formatDate(item.regDate, true)} | 조회 : ${item.readngCnt}`}
                      </div> */}
                        <div className="feedback-meta-subtext">
                          작성자 :&nbsp;
                          <span
                            className="feedback-nickname"
                            title={item.nickName}
                          >
                            {item.nickName}
                          </span>
                          {` | 작성일 : ${formatDate(item.regDate, true)} | 조회 : ${item.readngCnt}`}
                        </div>
                      </div>
                      <LikeButton
                        likesYn={item.likesYn}
                        likeCnt={item.likeCnt}
                        nttSn={item.nttSn}
                        fdbkType={item.fdbkType}
                      />
                    </div>
                  </div>
                ))}
              </div>
              {/* 높이 맞추기용 빈 아이템들 */}
              {emptyItems.map((_, index) => (
                <EmptyItem key={`empty-${index}`} />
              ))}
              {praiseCnt > 0 && (
                <div className="pagination-container">
                  <Pagination
                    totalCount={praiseCnt}
                    onPageChange={handlePageChange}
                    paramPage={page}
                  />
                </div>
              )}
            </>
          ) : (
            <NoResult />
          )}
        </div>
      ) : (
        <>
          <section
            className={`mobile-fb-reviews-section good-reviews ${activeTab === 'good' ? 'active' : ''}`}
            id="good-reviews"
          >
            <h2 className="mobile-fb-section-title">
              꿀소리 <PraiseIcon width="20px" height="20px" />
            </h2>
            <div className="mobile-fb-reviews-grid">
              {praiseList.map((item, index) => (
                <div className="mobile-fb-review-card" key={item.nttSn}>
                  <h3
                    className="mobile-fb-book-title"
                    onClick={() => handleDetailView(item.nttSn)}
                  >
                    {smartLineBreak(item.bizNm)}
                  </h3>
                  <div
                    className="mobile-fb-review-meta"
                    onClick={() => handleDetailView(item.nttSn)}
                  >
                    <span
                      className="mobile-fb-review-date"
                      onClick={() => handleDetailView(item.nttSn)}
                    >
                      {`라운드날짜 : ${formatDateString(item.rndDt)}`}
                    </span>
                  </div>
                  <div
                    className="mobile-fb-review-info"
                    onClick={() => handleDetailView(item.nttSn)}
                  >
                    <span
                      className="mobile-fb-author"
                      title={item.nttSj}
                      onClick={() => handleDetailView(item.nttSn)}
                    >
                      {item.nttSj}
                      {item.answerCnt ? (
                        <span className="feedback-answer-count">
                          [{item.answerCnt}]
                        </span>
                      ) : null}
                    </span>
                    {/* {item.answerCnt ? (
                    <span className="feedback-answer-count">
                      [{item.answerCnt}]
                    </span>
                  ) : null} */}
                    <span
                      className="mobile-fb-stats"
                      title={item.nickName}
                      onClick={() => handleDetailView(item.nttSn)}
                    >
                      {`작성자 : ${item.nickName} | 작성일 : ${formatDate(item.regDate, true)} | 조회 : ${item.readngCnt}`}
                    </span>
                  </div>
                  <button className="mobile-fb-like-btn">
                    <LikeButton
                      likesYn={item.likesYn}
                      likeCnt={item.likeCnt}
                      nttSn={item.nttSn}
                      fdbkType={item.fdbkType}
                      isMobile={isMobile}
                    />
                  </button>
                </div>
              ))}
            </div>
          </section>
          {praiseCnt > 0 && (
            <div className="pagination-container">
              <Pagination
                totalCount={praiseCnt}
                onPageChange={handlePageChange}
                paramPage={page}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}
